import styled, { keyframes } from 'styled-components';

const skeletonShimmer = keyframes`
  0% {
    background-position: -200px 0;
  }
  100% {
    background-position: calc(200px + 100%) 0;
  }
`;

export const SkeletonList = styled.div`
  display: flex;
  flex-direction: column;
  gap: 8px;
  padding: 5px 10px;
`;

export const SkeletonItem = styled.div`
  display: flex;
  flex-direction: column;
  height: 130px;
  gap: 16px;
  border-radius: 6px;
  padding: 24px;
  background-color: ${({ theme }) => theme.colors.background.light};
`;

export const SkeletonLine = styled.div<{ $width?: string }>`
  width: ${({ $width }) => $width || '100%'};
  height: 24px;
  border-radius: 6px;
  background: ${({ theme }) =>
    `linear-gradient(90deg, ${theme.colors.background.medium} 25%, ${theme.colors.background.light} 37%, ${theme.colors.background.medium} 63%)`};
  background-size: 400% 100%;
  animation: ${skeletonShimmer} 1.8s ease-in-out infinite alternate;
`;
